// const url= "http://localhost:5000/api/v1";

// const url= "https://iigqgbxnqj.execute-api.ap-south-1.amazonaws.com/dev/api/v1";
// const url= "https://58gmeu3tb4.execute-api.ap-south-1.amazonaws.com/staging/api/v1";
const url= "https://iwu5u49n5d.execute-api.ap-south-1.amazonaws.com/prod/api/v1";

let type=1
if(localStorage.getItem("vendor_data")){
    type = JSON.parse(localStorage.getItem("vendor_data")).seller_type
} 

let devconfig = {
    vendor: url + "/vendor/",
    admin: url + "/admin/",
    localVendor: url + "/local/vendor/",
    USER_APP: "https://www.truekhoj.com"
}
if(type>1){
    devconfig = {
        vendor: url + "/local/vendor/",
        admin: url + "/admin/",
        localVendor: url + "/local/vendor/",
        USER_APP: "https://www.truekhoj.com"
    }
}

module.exports = devconfig;
